import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../environment.service';

@Injectable()
export class AxwayInterceptorService implements HttpInterceptor {
  private environmentService: EnvironmentService;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.environmentService = this.injector.get(EnvironmentService);

    let newHeaders = req.headers;

    if (this.environmentService.isProd()) {
      newHeaders = newHeaders.append('x-hmhs-keyId', 'bcd19b23-8a39-451d-87d2-c9fa901eb6e2');
    } else if (this.environmentService.isQa()) {
      newHeaders = newHeaders.append('x-hmhs-keyId', '1a5496ae-f48a-4138-92bd-aa6ac2b00fe6');
    } else {
      newHeaders = newHeaders.append('x-hmhs-keyId', '9603261f-7b86-4537-99d5-c1970a4bd751');
    }

    if (!this.environmentService.isProd()) {
      newHeaders = newHeaders.append('x-hmhs-test-backend', this.environmentService.getAxwayBackendHeader());
    }

    const axwayReq = req.clone({ headers: newHeaders });

    return next.handle(axwayReq);
  }

  constructor(private injector: Injector) { }
}
